import type { BrokenContainerReportFieldsFragment } from '@/graphql/fragments/brokenContainerReport.generated';
import { BrokenContainerPart } from '@/graphql/generatedTypes';
import i18n, { getDateFormatOptions } from '@/utils/i18n';

export type BrokenContainerReportData = BrokenContainerReportFieldsFragment;
export type BrokenContainerLineData =
  BrokenContainerReportFieldsFragment['lines'][number];

export function formatBrokenReportDate(iso: string) {
  return new Date(iso).toLocaleDateString(
    i18n.language,
    getDateFormatOptions(true),
  );
}

export function brokenReportContextLabel(
  context: BrokenContainerReportData['context'],
) {
  return i18n.t(`BrokenContainers:context_${context}`);
}

export function brokenPartLabel(part: BrokenContainerPart) {
  return part === BrokenContainerPart.QrCode
    ? i18n.t('BrokenContainers:partQrCode')
    : i18n.t('BrokenContainers:partContainer');
}
